export const getBreakdownPercentage = (current: number, total: number): number => {
  if (current === 0) {
    return 0;
  } else if (total === 0) {
    return 100;
  } else {
    return Math.min(100, (current / total) * 100);
  }
};
